import React, { useCallback, useContext, useRef } from "react";
import {
  callApi,
  isEmpty,
  addZero,
  timeFormat,
  getDwk,
  recoverTag,
  blockEmoji,
} from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

type ConditionConfirmProp = {
  time: any;
  pass: any;
  chooseDate: any;
  member: any;
  handleReset: Function;
};

const ConditionAppointMentConfirmWrap = (prop: ConditionConfirmProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_APPOINTMENT",
      open: { cofirmConditionApoointment: false },
    });
    prop.handleReset();
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.cofirmConditionApoointment}
      onClose={handleClose}
      className="picker-pop auto"
    >
      {state.cofirmConditionApoointment && <ConditionAppointMentConfirm {...prop} />}
    </Drawer>
  );
};

const ConditionAppointMentConfirm = ({ time, pass, chooseDate, member }: ConditionConfirmProp) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach, partnerName, partnerBranchName } =
    useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const memo = useRef<HTMLTextAreaElement>(null);
  const imgUrl = isEmpty(member.imgUrl) ? empty : member.imgUrl;
  const from = timeFormat(time.reservationStartTime);
  const to = timeFormat(time.reservationEndTime);
  const date = new Date(
    `${chooseDate.year}-${addZero(chooseDate.month)}-${addZero(chooseDate.date)}`
  );
  const isLoadingRef = useRef<boolean>(false);
  const passName =
    pass.serviceName +
    " " +
    pass.usePeriod +
    "" +
    (pass.usePeriodType === "M" ? "개월" : "일") +
    " " +
    (isEmpty(pass.useNumber) ? "" : pass.useNumber * 1 > 0 ? pass.useNumber + "회" : "");

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_APPOINTMENT",
      open: { cofirmConditionApoointment: false },
    });
  }, []);

  const appointmentRsrv = () => {
    if (isLoadingRef.current === true) return;
    isLoadingRef.current = true;
    dispatch({ type: "LOADING_START" });
    callApi(
      "/schedule/reservation/appointment",
      {
        seqPartner,
        seqPartnerBranch,
        seqPartnerCoach,
        seqPassInfo: pass.seqPassInfo,
        seqMember: member.seqMember,
        startDt: `${chooseDate.year}-${addZero(chooseDate.month)}-${addZero(chooseDate.date)}`,
        startTime: time.reservationStartTime,
        memo: memo.current!.value,
      },
      "POST"
    )
      .then((res) => {
        if (res.MsgVO.msgCd === "CMAP2040-00") {
          handleClose();
          homeDispatch({ type: "UPDATE_SCHDULE" });
          dispatch({
            type: "UPDATE",
            data: { toast: true, toastText: "<span>개인레슨 스케줄</span>이 추가되었어요" },
          });
          isLoadingRef.current = false;
        } else {
          dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          isLoadingRef.current = false;
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
        isLoadingRef.current = false;
      });
  };

  const handleChangeMemo = () => {
    if (memo.current) {
      memo.current.value = blockEmoji(memo.current.value);
      if (memo.current.scrollHeight > 80) return;
      memo.current.style.height = "5px";
      memo.current.style.height = memo.current?.scrollHeight + "px";
    }
  };

  return (
    <div className="condition-confirm-pop">
      <img src={imgUrl} className="profile" />
      <div className="title">
        {member.name}님을
        <br />
        <span>개인레슨 예약</span> 할까요?
      </div>
      <div className="date-wrap">
        <ul>
          <li>
            {chooseDate.month}. {addZero(chooseDate.date)}{" "}
            <span className="gray"> &#183; {getDwk(date.getDay())}</span>
          </li>
          <li>
            {from.ampm} {from.time} - {to.ampm} {to.time}
          </li>
        </ul>
      </div>
      <div className="condition-schdule ap">
        <div className="lesson-decs">
          <div className="service-type">개인레슨</div>
          <div className="lesson-name">{recoverTag(passName)}</div>
          <div className="partner-name">
            {partnerName} {partnerBranchName} {pass.spaceName && <>&#183;</>} {pass.spaceName}
          </div>
        </div>
      </div>
      <div className="tip">
        예약 취소가 가능하며 변경은 CRM에서 가능합니다. 수업 종료시간까지 입장하지 않으면 자동
        결석처리 되며, 무단 결석 시 이용권의 남은 횟수가 차감됩니다.
      </div>
      <textarea
        className="memo"
        ref={memo}
        placeholder="스케줄 메모 입력"
        onChange={handleChangeMemo}
      ></textarea>
      <div className="tip textarea">예약 후, 스케줄 상세 페이지에서도 입력할 수 있어요.</div>
      <div className="member-decution-btn-wrap">
        <div className="btn cancle" onClick={handleClose}>
          취소
        </div>
        <div className="btn rsrv" onClick={appointmentRsrv}>
          예약하기
        </div>
      </div>
    </div>
  );
};

export default ConditionAppointMentConfirmWrap;
